export const SPLASH_SCREENS_VIEWS = {
  STRIPE_ADD_PAYOUT_DETAILS: 'stripe-add-payout-details',
  SUBSCRIPTION_ACCOUNT_VERIFICATION: 'subscription-account-verification',
  SUBSCRIPTION_TAP_TO_PAY: 'subscription-tap-to-pay',
  SUBSCRIPTION_NO_SHOW_PROTECTION: 'subscription-no-show-protection',
  SUBSCRIPTION_BOOKSY_CARD_READER: 'subscription-booksy-card-reader',
  BOOKSY_CARD_READER: 'booksy-card-reader',
  ACCOUNT_VERIFICATION: 'account-verification',
  SUBSCRIPTION_MOBILE_PAYMENTS: 'subscription-mobile-payments',
  TAP_TO_PAY: 'tap-to-pay',
  MOBILE_PAYMENTS: 'mobile-payments',
  NO_SHOW_PROTECTION: 'no-show-protection',
  SPLASH_NO_SHOWS: 'SPLASH_NO_SHOWS',
  SPLASH_HIGHER_PREPAYMENT: 'SPLASH_HIGHER_PREPAYMENT',
  BOOKSY_GIFT_CARDS: 'booksy-gift-cards',
  SPLASH_KEEP_PREPAYMENT: 'SPLASH_KEEP_PREPAYMENT',
  BOOKSY_PAY_ONBOARDING: 'SPLASH_PX_BP_ONBOARDING',
  BOOKSY_PAY_ACTIVATION: 'SPLASH_PX_BP_ACTIVATION',
}

export const SPLASH_SCREEN_ROUTING = {
  SUBSCRIPTION: {
    ACCOUNT_VERIFICATION: {
      name: 'settings-splash-screens',
      params: {
        splashScreen: SPLASH_SCREENS_VIEWS.SUBSCRIPTION_ACCOUNT_VERIFICATION,
      },
      query: {
        back_to: 'settings.payments',
      },
    },
    TAP_TO_PAY: {
      name: 'settings-splash-screens',
      params: {
        splashScreen: SPLASH_SCREENS_VIEWS.SUBSCRIPTION_TAP_TO_PAY,
      },
      query: {
        back_to: 'settings.payments',
      },
    },
    MOBILE_PAYMENTS: {
      name: 'settings-splash-screens',
      params: {
        splashScreen: SPLASH_SCREENS_VIEWS.SUBSCRIPTION_MOBILE_PAYMENTS,
      },
      query: {
        back_to: 'settings.payments',
      },
    },
    NO_SHOW_PROTECTION: {
      name: 'settings-splash-screens',
      params: {
        splashScreen: SPLASH_SCREENS_VIEWS.SUBSCRIPTION_NO_SHOW_PROTECTION,
      },
      query: {
        back_to: 'settings.payments',
      },
    },
    BOOKSY_CARD_READER: {
      name: 'settings-splash-screens',
      params: {
        splashScreen: SPLASH_SCREENS_VIEWS.SUBSCRIPTION_BOOKSY_CARD_READER,
      },
      query: {
        back_to: 'settings.payments',
      },
    },
  },
  ENABLE_FEATURE: {
    ACCOUNT_VERIFICATION: {
      name: 'settings-splash-screens',
      params: {
        splashScreen: SPLASH_SCREENS_VIEWS.ACCOUNT_VERIFICATION,
      },
      query: {
        back_to: 'settings.payments',
      },
    },
    TAP_TO_PAY: {
      name: 'settings-splash-screens',
      params: {
        splashScreen: SPLASH_SCREENS_VIEWS.TAP_TO_PAY,
      },
      query: {
        back_to: 'settings.payments',
      },
    },
    MOBILE_PAYMENTS: {
      name: 'settings-splash-screens',
      params: {
        splashScreen: SPLASH_SCREENS_VIEWS.MOBILE_PAYMENTS,
      },
      query: {
        back_to: 'settings.payments',
      },
    },
    NO_SHOW_PROTECTION: {
      name: 'settings-splash-screens',
      params: {
        splashScreen: SPLASH_SCREENS_VIEWS.NO_SHOW_PROTECTION,
      },
      query: {
        back_to: 'settings.payments',
        return_route: 'settings.payments-no-show-protection',
      },
    },
    BOOKSY_CARD_READER: {
      name: 'settings-splash-screens',
      params: {
        splashScreen: SPLASH_SCREENS_VIEWS.BOOKSY_CARD_READER,
      },
      query: {
        back_to: 'settings.payments',
        return_route: 'settings.payments.payment-types.booksy-card-reader',
      },
    },
    BOOKSY_GIFT_CARDS: {
      name: 'settings-splash-screens',
      params: {
        splashScreen: SPLASH_SCREENS_VIEWS.BOOKSY_GIFT_CARDS,
      },
      query: {
        back_to: 'settings.payments',
      },
    },
    BOOKSY_PAY_ONBOARDING: {
      name: 'settings-splash-screens',
      params: {
        splashScreen: SPLASH_SCREENS_VIEWS.BOOKSY_PAY_ONBOARDING,
      },
    },
    BOOKSY_PAY_ACTIVATION: {
      name: 'settings-splash-screens',
      params: {
        splashScreen: SPLASH_SCREENS_VIEWS.BOOKSY_PAY_ACTIVATION,
      },
      query: {
        back_to: 'calendar',
      },
    },
  },
  SPLASH_NO_SHOWS: {
    name: 'settings-splash-screens',
    params: {
      splashScreen: SPLASH_SCREENS_VIEWS.SPLASH_NO_SHOWS,
    },
    query: {
      back_to: 'calendar',
      return_route: 'settings.payments-no-show-protection',
    },
  },
  SPLASH_HIGHER_PREPAYMENT: {
    name: 'settings-splash-screens',
    params: {
      splashScreen: SPLASH_SCREENS_VIEWS.SPLASH_HIGHER_PREPAYMENT,
    },
    query: {
      back_to: 'calendar',
    },
  },
  SPLASH_KEEP_PREPAYMENT: {
    name: 'settings-splash-screens',
    params: {
      splashScreen: SPLASH_SCREENS_VIEWS.SPLASH_KEEP_PREPAYMENT,
    },
    query: {
      back_to: 'calendar',
    },
  },
}
